import { ROLE_PERMISSIONS } from '@irl/types';
export function hasPermission(role, customPermissions, required) {
    if (customPermissions.includes(required)) {
        return true;
    }
    return ROLE_PERMISSIONS[role].includes(required);
}
//# sourceMappingURL=permissions.js.map